import { NgModule } from '@angular/core';
import { AesDecryptPipe } from './aes-decrypt.pipe';
import { JsonParsePipe } from './json-parse.pipe';

@NgModule({
    imports: [],
  exports: [AesDecryptPipe, JsonParsePipe],
  declarations: [AesDecryptPipe, JsonParsePipe],
    providers : []
})
export class PipeModule { }
